import { Box, Button } from '@mui/material';
import { Form, Formik } from 'formik';

import { Card } from 'src/components';
import { showErrorToast } from 'src/components/Toasts/toast';
import { useAddPartnerContext } from 'src/contexts/AddPartnerProvider';
import { useAuthContext } from 'src/contexts/AuthProvider';
import { isIreland } from 'src/lib/countryConfig';
import { getCurrencyCodeBasedOnRegion } from 'src/utils/utils';

import SelectPartnerType from '../components/SelectPartnerType';
import { step1ValidationSchema } from '../validation/Step1';

export const Step1 = () => {
    // Context
    const { application, addPartner, activeStep } = useAddPartnerContext();
    const { user } = useAuthContext();

    const initialValues = {
        partnerType: '',
        topLevelPartner:
            (user?.business?.partnerId && user?.business?.partnerId.toString()) ||
            application?.partnerId?.toString() ||
            '',
        country: application?.country || (isIreland ? 'Ireland' : ''),
        currency: getCurrencyCodeBasedOnRegion(),
        ...application,
    };

    return (
        <Formik
            initialValues={initialValues}
            onSubmit={async ({ partnerType, topLevelPartner, country }) => {
                await addPartner(
                    { partnerType, partnerId: Number(topLevelPartner), step: 1, country },
                    activeStep
                );
            }}
            enableReinitialize
            validationSchema={step1ValidationSchema}
        >
            {(formikProps) => {
                return (
                    <Form>
                        <Box display="flex" flexDirection="column">
                            <Card heading="Partner Types">
                                <SelectPartnerType />

                                <Box display="flex" justifyContent="flex-end">
                                    <Button
                                        data-testid="add-partner-next-button"
                                        sx={{
                                            alignSelf: 'end',
                                            marginTop: '24px',
                                        }}
                                        type="submit"
                                        variant="main"
                                        onClick={async () => {
                                            try {
                                                await step1ValidationSchema.validate(
                                                    formikProps.values
                                                );
                                            } catch (error) {
                                                showErrorToast('Please fill in required fields');
                                            }
                                        }}
                                    >
                                        Next
                                    </Button>
                                </Box>
                            </Card>
                        </Box>
                    </Form>
                );
            }}
        </Formik>
    );
};
